module.exports = __webpack_public_path__ + "img/mq_3.a63f7b04.svg";